import { render, staticRenderFns } from "./WholesalerTariffDialog.vue?vue&type=template&id=68ff9ce0&scoped=true&"
import script from "./WholesalerTariffDialog.vue?vue&type=script&lang=ts&"
export * from "./WholesalerTariffDialog.vue?vue&type=script&lang=ts&"
import style0 from "./WholesalerTariffDialog.vue?vue&type=style&index=0&id=68ff9ce0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68ff9ce0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VCardText,VCol,VContainer,VDivider,VForm,VRow,VSwitch,VTextField,VTextarea})
